<template>
  <DashboardLayout>
    <div class="settings-hub">
      <div class="settings-nav-panel">
        <div class="settings-hub-title-wrap">
          <h1 class="settings-hub-title">Settings</h1>
        </div>

        <div class="settings-nav-group">
          <div class="settings-nav-group-label">ACCOUNT</div>
          <router-link
            to="/settings/product-tracking"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" fill="currentColor"/>
            </svg>
            <span>Product Tracking</span>
          </router-link>
          <router-link
            to="/settings/account"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" fill="currentColor"/>
            </svg>
            <span>Account &amp; Team</span>
          </router-link>
        </div>

        <div class="settings-nav-group">
          <div class="settings-nav-group-label">NOTIFICATIONS</div>
          <router-link
            to="/settings/alerts"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" fill="currentColor"/>
            </svg>
            <span>Alert Settings</span>
          </router-link>
          <router-link
            to="/settings/sellers"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" fill="currentColor"/>
            </svg>
            <span>Hijacker</span>
          </router-link>
        </div>

        <div class="settings-nav-group">
          <div class="settings-nav-group-label">BILLING &amp; COSTS</div>
          <router-link
            to="/settings/billing"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" fill="currentColor"/>
            </svg>
            <span>Subscription &amp; Billing</span>
          </router-link>
          <router-link
            to="/settings/bulk-cogs"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" fill="currentColor"/>
            </svg>
            <span>Bulk COGS &amp; Margins</span>
          </router-link>
        </div>

        <div class="settings-nav-group">
          <div class="settings-nav-group-label">INTEGRATIONS</div>
          <router-link
            to="/settings/webhooks"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"/>
            </svg>
            <span>Webhooks</span>
          </router-link>
          <router-link
            to="/settings/api-keys"
            class="settings-nav-item"
            active-class="active"
            exact
          >
            <svg class="settings-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" fill="currentColor"/>
            </svg>
            <span>API Keys</span>
          </router-link>
        </div>
      </div>

      <div class="settings-content-panel">
        <router-view></router-view>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from './components/buybox/DashboardLayout.vue'

export default {
  name: 'SettingsHubPage',
  components: {
    DashboardLayout
  },
  mounted: function () {
    this.clearStuckPageDimmer()
  },
  methods: {
    clearStuckPageDimmer: function () {
      try {
        $('body').removeClass('dimmed')
        var $dimmer = $('.ui.dimmer.modals')
        $dimmer.removeClass('visible active animating')
        $dimmer.find('.ui.modal').removeClass('visible active animating')
        $dimmer.css({ display: 'none', 'background-color': '' })
      } catch (e) {}
    }
  }
}
</script>

<style scoped>
.settings-hub {
  display: flex;
  min-height: calc(100vh - 60px);
}

.settings-nav-panel {
  width: 215px;
  flex-shrink: 0;
  border-right: 1px solid rgb(237, 242, 246);
  padding: 20px 0 28px;
  background: var(--bg-white);
  box-shadow: 6px 0 24px rgba(18, 46, 82, 0.045);
  position: sticky;
  top: 60px;
  align-self: flex-start;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.settings-hub-title-wrap {
  padding: 0 16px 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgb(239, 244, 248);
}

.settings-hub-title {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--primary-navy);
  margin: 0;
}

.settings-nav-group {
  margin-bottom: 0;
}

.settings-nav-group + .settings-nav-group {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgb(237, 242, 246);
}

.settings-nav-group-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: rgb(154, 164, 176);
  margin-bottom: 6px;
  padding: 0 16px;
}

.settings-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px 9px 13px;
  margin: 0;
  border-radius: 0;
  border-left: 3px solid transparent;
  color: rgb(113, 128, 145);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
  box-sizing: border-box;
}

.settings-nav-item:hover {
  background: rgba(248, 250, 252, 0.95);
  color: rgb(55, 71, 94);
}

.settings-nav-item.active {
  background: rgb(240, 247, 255);
  color: var(--primary-navy);
  border-left-color: var(--primary-navy);
  font-weight: 600;
}

.settings-nav-icon {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  color: currentColor;
  opacity: 0.94;
}

.settings-content-panel {
  flex: 1;
  min-width: 0;
  padding: 28px 28px 32px;
  background: var(--bg-light);
}
</style>



// WEBPACK FOOTER //
// SettingsHubPage.vue?b95d5c72